<template>
  <div v-if="isShow" class="address bg_white">
    <h1 class="content_title">配達先住所</h1>

    <div class="address_form form">
      <p class="message ab" v-bind:class="{'mt16': this.message}">{{ this.message }}</p>
      <div class="form_list">
        <p class="form_title ar c5a">郵便番号<span class="required">必須</span></p>
        <div class="error ar">{{ this.error.zipErrorMessage }}</div>
        <div class="zip_wrap">
          <input v-model="submitData.deliveryAddress.address.zipCode" class="form_input" type="tel" maxlength="8" name="zip" value="">
          <button @click="searchZip" class="btn_zip btn_yellow btn_mini">住所検索</button>
        </div>

      </div>
      <div class="form_list">
        <p class="form_title ar c5a">都道府県<span class="required">必須</span></p>
        <div class="error ar">{{ this.error.prefectureErrorMessage }}</div>
        <div class="select_wrap">
          <PrefectureList v-bind:status="send" v-bind:autoPrefectureId="submitData.deliveryAddress.address.prefecture.prefectureId" @selectPrefecture="recievePrefecture" />
        </div>
      </div>
      <div class="form_list">
        <p class="form_title ar c5a">住所<span class="required">必須</span></p>
        <div class="error ar">{{ this.error.addressErrorMessage }}</div>
        <input v-model="submitData.deliveryAddress.address.address" class="form_input" type="text" name="address" value="">
      </div>
      <div class="form_list">
        <p class="form_title ar c5a">電話番号</p>
        <input v-model="submitData.deliveryAddress.contactInfo.phoneNumber" class="form_input" type="tel" name="tel" value="">
      </div>
      <div class="form_list">
        <p class="form_title ar c5a">FAX番号</p>
        <input v-model="submitData.deliveryAddress.contactInfo.faxNumber" class="form_input" type="tel" name="fax" value="">
      </div>
      <div v-if="isSetAsBcDefaultDeliveryAddress" class="form_list">
        <!-- <p class="form_title ar c5a">現在のBCのお届け先に設定する</p> -->
        <div class="kodomo_wrap">
          <input class="kodomo_check" type="checkbox" id="set_as_bc_delivery" name="set_as_bc_delivery" v-model="submitData.setAsBcDefaultDeliveryAddress" />
          <label for="set_as_bc_delivery" class="checkbox01 ab c5a">BC{{submitData.bcNo}}のお届け先に設定する</label>
        </div>
      </div>

      <button class="btn_regist btn_blue" @click="checkForm()" type="button" name="button">登録</button>
      <router-link v-if="this.$route.query.redirect_url" class="btn_back btn_delete" :to="{ name: this.$route.query.redirect_url, query: {status: 'addDeliveryAddress'} }">戻る</router-link>

    </div>
  </div>
  <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
</template>

<script>
import PrefectureList from '@/components/common/PrefectureList'
import Check from '@/model/getToken'
import DeliveryAddress from '@/components/api/deliveryAddress'
import Zip from '@/components/api/zip'

export default {
  components: {
    PrefectureList,
  },
  data() {
    return {
      isShow: true,
      message: '',
      send: false,
      zip: '',
      error: {
        zipErrorMessage: '',
        prefectureErrorMessage: '',
        addressErrorMessage: ''
      },
      submitData: {
        bcNo: this.$route.query.bcNo || '001',
        setAsBcDefaultDeliveryAddress: true,
        deliveryAddress: {
          address: {
            address: '',
            prefecture: {
              prefectureId: 0,
              prefectureName: ''
            },
            zipCode: ''
          },
          contactInfo: {
            faxNumber: '',
            mobilePhoneNumber: '',
            phoneNumber: ''
          },
          deliveryAddressId: 0,
          recipientName: '',
        }
      }

    }
  },
  methods: {
    searchZip() {
      Zip.search(this.submitData.deliveryAddress.address.zipCode).then((val) => {
        this.submitData.deliveryAddress.address.prefecture.prefectureId = '';
        this.submitData.deliveryAddress.address.prefecture.prefectureName = '';
        this.submitData.deliveryAddress.address.address = '';
        if(val) {
          this.submitData.deliveryAddress.address.prefecture.prefectureId = val.prefecture.prefectureId;
          this.submitData.deliveryAddress.address.prefecture.prefectureName = val.prefecture.prefectureName;

          this.submitData.deliveryAddress.address.address = val.address;
        }

        // console.log(val);
      });
    },
    recievePrefecture(data) {
      this.submitData.deliveryAddress.address.prefecture.prefectureId = data.prefectureId;
      this.submitData.deliveryAddress.address.prefecture.prefectureName = data.prefectureName;
    },
    checkForm() {
      console.log('登録');
      this.error.zipErrorMessage = '';
      this.error.prefectureErrorMessage = '';
      this.error.addressErrorMessage = '';
      let error = false;
      if(!this.submitData.deliveryAddress.address.zipCode) {
        this.error.zipErrorMessage = '郵便番号は必須です。';
        error = true;
      } else if(this.submitData.deliveryAddress.address.zipCode.length != 7) {
        this.error.zipErrorMessage = '郵便番号は7桁で入力してください。';
        error = true;
      }

      if(!this.submitData.deliveryAddress.address.prefecture.prefectureName) {
        this.error.prefectureErrorMessage = '都道府県は必須です。';
        error = true;
      }

      if(!this.submitData.deliveryAddress.address.address) {
        this.error.addressErrorMessage = '住所は必須です。';
        error = true;
      }

      // バリデーションエラーがなければ送信
      if (error) {
        console.log('error');
        return true;
      }
      console.log('送信');

      // e.preventDefault();
      this.createDeriveryAddress();
    },
    init() {
      this.submitData.deliveryAddress.address.address = '';
      this.submitData.deliveryAddress.address.prefecture.prefectureId = 0;
      this.submitData.deliveryAddress.address.prefecture.prefectureName = '';
      this.submitData.deliveryAddress.address.zipCode = '';
      this.submitData.deliveryAddress.contactInfo.faxNumber = '';
      this.submitData.deliveryAddress.contactInfo.mobilePhoneNumber = '';
      this.submitData.deliveryAddress.contactInfo.phoneNumber = '';
      this.submitData.deliveryAddressId = 0;
      this.submitData.recipientName = '';
      this.submitData.setAsBcDefaultDeliveryAddress = true;
      this.submitData.bcNo = this.$route.query.bcNo || '001';
      this.send = true; // コンポーネント受け渡し用
    },
    async createDeriveryAddress() {
      // 購入フローでは bcNo を送らない
      let payload = JSON.parse(JSON.stringify(this.submitData));
      if (this.$route.query.redirect_url === 'purchaseSelectPaymentAndShipping') {
        delete payload.bcNo;
      }
      await DeliveryAddress.createDeliveryAddress(payload).then((val) => {
        if(val == 'OK') {
          if(this.$route.query.redirect_url) {
            this.$router.push({ name: this.$route.query.redirect_url, query: {status: 'addDeliveryAddress'} });
          } else {
            this.message = '住所の追加が完了しました。';
          }
          this.init();
        } else {
          this.message = '住所の追加に失敗しました。';
        }
      });
    },
  },
  computed: {
    isSetAsBcDefaultDeliveryAddress() {
      return this.$route.query.redirect_url !== 'purchaseSelectPaymentAndShipping';
    }
  },
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(!res) {
      this.isShow = false;
    }
  },
  // watch: {
  //   zip() {
  //     Zip.search(this.zip).then((val) => {
  //       console.log(val);
  //     });
  //   }
  // }
}
</script>

<style lang="css" scoped>
.message {

}
.error {
  color: #FF4343;
  font-size: 14px;
  margin: 10px 0 -10px;
}

.address {
  -webkit-overflow-scrolling: touch;
  padding: 18px 0 60px;
}

.content_title {
  display: inline-block;
  padding-right: 32px;
}

.address_form {
  margin: auto;
  width: 91.5%;
}

.required {
  background-color: #FF4343;
  border-radius: 60px;
  color: #fff;
  display: inline-block;
  font-size: 10px;
  max-width: 39px;
  margin-left: 8px;
  text-align: center;
  width: 100%;
}

.form_list {
  margin-top: 20px;
}

.form_title {
  font-size: 12px;
}

.form_input {
  border: 1px solid #c9c9c9!important;
  font-size: 16px;
  margin-top: 10px;
  /* padding-top: 10px; */
  padding: 5px;
  width: 100%;
}

.select_wrap::after {
  right: 5px;
  top: 40%;
}

.btn_regist {
  margin-top: 60px;
  width: 100%;
}

.btn_back {
  margin-top: 30px;
  width: 100%;
  /* margin-bottom: 100px; */
}

.zip_wrap {
  align-items: center;
  display: flex;
  margin-top: 20px;
}
.zip_wrap .form_input {
  margin-top: 0;
}
.btn_zip {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/member/AddAddress.vue